import DriverContractsDriversListResponse from "../../../../api/raily/driver/contracts/drivers-list/driver-contracts-drivers-list.response";
import DriverContractsDriversList from "./driver-contracts-drivers-list";

const create = (
  response: DriverContractsDriversListResponse,
): DriverContractsDriversList => {
  const data = response.data;

  return {
    firstName: data.firstName,
    lastName: data.lastName,
  };
};

const driverContractsDriversListFactory = {
  create,
};

export default driverContractsDriversListFactory;
